export const getNumberWithSpacesAndDot = (x: number, precision?: number): string => {
  // transform x to string with precision decimals and space as thousands separator
  const [integerPart, decimalPart] = x.toFixed(precision).split('.')
  const integerPartWithSpaces = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return decimalPart ? `${integerPartWithSpaces}.${decimalPart}` : integerPartWithSpaces
}

export const formatVariationValue = (value: number, decimals?: number): string => {
  if (value % 1 === 0 || value > 100 || value < -100) {
    return value.toFixed(0)
  }

  return value.toFixed(decimals || 2)
}

export const getNumberWithSpaces = (x: number | string): string => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

export const formatDecimalNumber = (value: number, decimals?: number): string => {
  const numberOfDecimals = decimals !== undefined ? decimals : value >= 1000 ? 0 : 2
  return getNumberWithSpaces(value.toFixed(numberOfDecimals))
}

/**
 * It takes a numerical value and returns it either with spaces as delimiters for thousands (case of an integer), or fixed to the second decimal (case of a float). Undoubtedly strings in both cases.
 * @param value the number we want to format
 * @param decimals (optional) the number of digits to appear after the decimal point; it defaults to 2.
 * @return a string
 * @example
 * if `value` is `1234567`, output will be `"1 234 567"`
 * if `value` is `0.1234567` and `decimals` was omitted, output will be `"0.12"`
 * if `value` is `0.1234567` and `decimals` is `5`, output will be `"0.12346"`
 */
export const formatValue = (value: number, decimals: number = 2): string =>
  value % 1 === 0 ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : value.toFixed(decimals)
